module.exports = __webpack_public_path__ + "static/media/Project1_Demo5.39ad244f.png";